import React from 'react';
import Info from '../../contenedores/Info';

const NotFound = ({ history }) => {
  return <Info history={history} es404 />
};

export default NotFound;
